import { createBrowserClient } from '@supabase/ssr'
import { makeTimeoutFetch, USER_CLIENT_TIMEOUTS } from './timeout-fetch'
import { installWebStorageShims } from '@/lib/utils/storage-shim'

// Web 프로젝트 전용 쿠키 이름 (admin과 세션 분리)
export const SUPABASE_COOKIE_NAME = 'sb-web-auth-token';

// 쿠키 유효 기간: 400일 (브라우저 최대 허용 기간)
// iOS PWA에서 세션이 유지되려면 maxAge 필수
export const COOKIE_MAX_AGE = 60 * 60 * 24 * 400; // 400 days in seconds

const browserClientFetch = makeTimeoutFetch(USER_CLIENT_TIMEOUTS);

let client: ReturnType<typeof createBrowserClient> | null = null;

function construct() {
  return createBrowserClient(
    process.env.NEXT_PUBLIC_SUPABASE_URL!,
    process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY!,
    {
      global: { fetch: browserClientFetch },
      cookieOptions: {
        name: SUPABASE_COOKIE_NAME,
        maxAge: COOKIE_MAX_AGE,
        sameSite: 'lax',
        secure: process.env.NODE_ENV === 'production',
      },
    }
  );
}

export function createClient() {
  if (!client) {
    try {
      client = construct();
    } catch (error) {
      // realtime-js가 내부에서 만드는 Phoenix Socket이 window.sessionStorage를
      // 읽는데, Safari "모든 쿠키 차단" 환경에서는 그 접근이 SecurityError를
      // 던진다(LOCARORA-WEB-6C / 6D). instrumentation-client가 이미 shim을
      // 깔지만, 그보다 먼저 실행되는 경로 대비 벨트 앤 브레이스.
      const e = error as { name?: string; message?: string } | null;
      const isStorageSecurityError =
        e?.name === 'SecurityError' || Boolean(e?.message?.includes('insecure'));
      if (!isStorageSecurityError) throw error;

      installWebStorageShims();
      client = construct(); // 재시도 실패 시에는 그대로 throw (client는 null 유지)
    }
  }
  return client;
}
